import { format } from "date-fns";

import { PeriodModel } from "@interfaces/index";

export const formatPeriodRange = (period: PeriodModel) =>
  `${format(new Date(period.startDate), "MMM yy")} – ${format(new Date(period.endDate), "MMM yy")}`;
